const React = require('react');
const ButtonBase = require('@material-ui/core/ButtonBase').default;
const DoneIcon = require('@material-ui/icons/Done').default;
const IconButton = require('@material-ui/core/IconButton').default;
const CloseIcon = require('../../../icons/Close');
const Slot = require('./Slot');


module.exports = (props) => {
  const {
    name,
  } = props;
  return (
    <Slot className="mb10">
      <DoneIcon className="w(|min)30 cF"/>
      <div className="ml20 pr50">
        <div>{props.label}</div>
        {
          name ? (
            <div
              className="mt10 cF"
            >{name}</div>
          ) : null
        }
        <div
          className="mt5 cF"
        >Upload another doc</div>
      </div>
      {
        props.disabled ? null : (
          <ButtonBase
            className="dB*2 abs*2 s"
            component="div"
            onClick={props.onClick}
          />
        )
      }
      <IconButton
        className="abs*2 srt5 cF*2 z1"
        onClick={props.onRemove}
      >
        <CloseIcon
          className="w18 cF"
        />
      </IconButton>
    </Slot>
  );
};
